export enum Role {
  ADMIN = 'Администратор',
  DIRECTOR = 'Директор',
  MANAGER = 'Менеджер',
}
